import { render, staticRenderFns } from "./mergeEmployee.vue?vue&type=template&id=23379ba5"
import script from "./mergeEmployee.vue?vue&type=script&lang=js"
export * from "./mergeEmployee.vue?vue&type=script&lang=js"
import style0 from "./mergeEmployee.vue?vue&type=style&index=0&id=23379ba5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports